import React from "react";
import styled from "styled-components";
import { TextBadge } from "..";

const Legend = ({ data }) => {
  return (
    <LegendContainer>
      {data.map((item, index) => (
        <LegendItem key={index}>
          <LegendColor $fillcolor={item.color} />
          <TextBadge>{item.text}</TextBadge>
        </LegendItem>
      ))}
    </LegendContainer>
  );
};

const LegendContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const LegendItem = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
  gap: 0 0.5rem;
`;

const LegendColor = styled.div`
  width: 1rem;
  height: 1rem;
  background-color: ${(props) => props.$fillcolor};
  border: ${(props) =>
    props.$fillcolor === "var(--White)"
      ? "var(--border-width) solid var(--Gray)"
      : "none"};
`;

export { Legend };
